/**
 * useTemplates.js
 *
 * React Query hooks for messaging templates data.
 *
 * Usage:
 *   const { templates, isLoading, refetch } = useTemplates();
 */

import { useQuery } from '@tanstack/react-query';
import { templateService } from 'services/api';

export const templateKeys = {
  all: ['messaging-templates'],
};

const EMPTY_ARRAY = [];

/**
 * Fetch WhatsApp messaging templates.
 * Replaces legacy GetTemplate + templates state in MyContextProvider.js.
 */
export const useTemplates = (options = {}) => {
  const { data: templates = EMPTY_ARRAY, ...rest } = useQuery({
    queryKey: templateKeys.all,
    queryFn: () => templateService.getMessagingTemplates(),
    select: (data) => data?.data ?? EMPTY_ARRAY,
    ...options,
  });

  return { templates, ...rest };
};
